export default function formieInit() {
  const inputFiles = document.querySelectorAll('.fui-input[type="file"]');

  inputFiles.forEach((inputFile) => {
    inputFile.addEventListener('change', () => {
      inputFile.classList.toggle('has-file', inputFile.files.length > 0);
    });
  });
}
